export default {
  请先选择一个部门: "请先选择一个部门",
  选择部门: "选择部门",
  请输入部门名称: "请输入部门名称",
};
